import {useGetAndSet} from "./useGetAndSet";
import {createSetVehicleStatusCountDataAction} from "../actions/dataActions";


export const useVehicleStatusCountData = (params, dataFresh) => {
    return useGetAndSet("vehiclestatuscount", params,createSetVehicleStatusCountDataAction, dataFresh);
}